// The API returns timestamps like "2026-08-11T09:55:56.756765" - a UTC
// instant, but without a trailing "Z"/offset. Per the ECMAScript Date spec,
// an ISO date-time string with no timezone designator is parsed as *local*
// time, not UTC, so `new Date(value)` silently skips the UTC->local
// conversion instead of performing it. Force UTC interpretation by
// appending "Z" when the string doesn't already carry a zone marker.
export const parseApiDate = (value) => {
    if (!value) return null;
    const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(value);
    return new Date(hasTimezone ? value : `${value}Z`);
};
